import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import useOpenGRView from '../../hooks/useOpenGRView';
import { selectIsGRPlayable } from '../../selectors/runtime.selector';

import GRBanner from './GRBanner';
import makeSelectGRBannerPropsSelector from './GRBanner.selector';

type GRBannerContainerProps = {
  className?: string;
};

const GRBannerContainer = (ownProps: GRBannerContainerProps) => {
  const selector = useMemo(() => makeSelectGRBannerPropsSelector(), []);
  const selectedProps = useSelector(selector);
  const isGRPlayable = useSelector(selectIsGRPlayable);
  const openGRView = useOpenGRView();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e) {
        e.stopPropagation();
      }

      openGRView();
    },
    [openGRView],
  );

  const otherProps = useMemo(
    () => ({
      onClick,
    }),
    [onClick],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return isGRPlayable ? <GRBanner {...enhancedProps} /> : null;
};

export default GRBannerContainer;
